import { Injectable } from '@angular/core';

import { SyncUserSettingsService } from '@frontend/sports/user/feature';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { concatMap, filter, map } from 'rxjs';

import { betslipSelector, selectIsLinearBetslip } from '../../base/store/selectors';
import { IBetslipRootState } from '../../base/store/state';
import BetbuilderActions from '../bet-builder/actions';
import BetslipComboBetActions from '../combo-bet/actions';
import BetslipPickActions from '../picks/actions';
import BetslipSingleBetActions from '../single-bet/actions';
import BetslipSystemBetActions from '../system-bet/actions';
import { BetslipStakeActions } from './actions';

@Injectable()
export class StakeEffects {
    constructor(
        private actions$: Actions,
        private store: Store<IBetslipRootState>,
        private userSettings: SyncUserSettingsService,
    ) {}

    notifyStakeChanges$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(
                BetslipSingleBetActions.setSingleBetStake,
                BetslipSingleBetActions.setSingleBetPickStake,
                BetslipSystemBetActions.setSystemBetStake,
                BetslipSystemBetActions.setSystemBetTypeStakeValue,
                BetslipComboBetActions.setComboBetStake,
                BetbuilderActions.setPickStake,
            ),
            filter((action) => !action.silent),
            map((_) => BetslipStakeActions.notifyStakeChanges()),
        );
    });

    setDefaultStake$ = createEffect(() => {
        const elem = this;

        return this.actions$.pipe(
            ofType(BetslipPickActions.addPick),
            concatLatestFrom(() => this.store.select(betslipSelector)),
            filter(([_, state]) => state.picks.pickList.length === 1 && (!!state.types.comboBet.stake || !!state.types.systemBet.stake)),
            concatLatestFrom(() => this.store.select(selectIsLinearBetslip)),
            filter(([_, isLinear]) => !isLinear),
            concatMap(function* (): Iterable<Action> {
                const defaultStake = elem.userSettings.bettingSettings.defaultStake || null;

                yield BetslipComboBetActions.setComboBetStake({
                    stake: defaultStake,
                    stakeStr: defaultStake?.toString(),
                });
                yield BetslipSystemBetActions.setSystemBetStake({
                    stake: defaultStake,
                    stakeStr: defaultStake?.toString() || null,
                });
            }),
        );
    });
}
